var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-chip",class:{focused: _vm.focused},style:({'background': _vm.colorHex})})}
var staticRenderFns = []

export { render, staticRenderFns }